import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material";
// import "jspdf-autotable";

// const columns =

export default function DataGridDemo({
  coulmns,
  rows,
  handleRowSelection,
  selectionRows,
  adminUser,
}) {
  // console.log("rows");

  const theme = createTheme({
    direction: "rtl",
  });

  function convertToCSV(data) {
    const rows = [];
    const columnHeaders = [];

    // Extract column headers
    const columns = coulmns; // Assuming you have defined your columns somewhere
    for (const column of columns) {
      columnHeaders.push(column.headerName);
    }
    rows.push(columnHeaders.join(","));

    // Extract data rows and modify the "status" field
    for (const row of data) {
      const rowData = columns.map((column) => {
        return row[column.field];
      });
      rows.push(rowData.join(","));
    }

    return rows.join("\n");
  }

  function downloadCSV() {
    const csvData = convertToCSV(rows); // Assuming 'rows' is your data

    // Create a Blob with UTF-8 encoding
    const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvData], {
      type: "text/csv;charset=utf-8",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "exported_data.csv";

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  }

  return (
    <ThemeProvider theme={theme}>
      {adminUser ? (
        <button className="exportcsv" onClick={downloadCSV}>
          تصدير كملف CSV
        </button>
      ) : null}

      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={coulmns}
          onRowSelectionModelChange={handleRowSelection}
          pageSize={10}
          checkboxSelection={selectionRows}
          sorting={true}
          disableRowSelectionOnClick
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              printOptions: {
                pageStyle:
                  ".MuiDataGrid-root .MuiDataGrid-main { color: rgba(0, 0, 0, 0.87); }",
              },
            },
          }}
          localeText={{
            toolbarDensity: "المقاس",
            toolbarDensityLabel: "المقاس",
            toolbarDensityCompact: "صغير",
            toolbarDensityStandard: "متوسط",
            toolbarDensityComfortable: "كبير",
            toolbarFilters: "تصفية",
            toolbarFiltersLabel: "تصفية",
            toolbarFiltersTooltipHide: "إخفاء التصفية",
            toolbarFiltersTooltipShow: "عرض التصفية",
            filterOperatorContains: "يحتوي",
            filterOperatorEquals: "مساوٍ لـ",
            filterOperatorNotEquals: "غير مساوٍ لـ",
            filterOperatorStartsWith: "يبدأ بـ",
            filterOperatorEndsWith: "ينتهي بـ",
            filterOperatorIs: "هو",
            filterOperatorIsNot: "ليس هو",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "ليس فارغ",
            toolbarFiltersTooltipHide: "إخفاء التصفية",
            toolbarFiltersTooltipShow: "عرض التصفية",
            toolbarExport: "تصدير",
            toolbarExportLabel: "تصدير",
            toolbarExportCSV: "تصدير كملف CSV",
            toolbarExportPrint: "طباعه",
            toolbarColumns: "اعمده",
            // Add more translations as needed
            // columnMenuUnsort: "",
            columnMenuSortAsc: "ترتيب تصاعدي",
            columnMenuSortDesc: "ترتيب تنازلي",
            columnMenuFilter: "تصفيه",
            columnMenuHideColumn: "اخفاء العمود",
            columnMenuManageColumns: "اداره الاعمده",
          }}
        />
      </Box>
    </ThemeProvider>
  );
}
